import {
  Box,
  Heading,
  Image,
  SimpleGrid,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import React from "react";
import Aos from "aos";
import "aos/dist/aos.css";
import styles from "./Css/About.module.css";



export default function AboutMe() {
  React.useEffect(() => {
    Aos.init({
      duration: 1000,
      anchorPlacement: "center-bottom", // defines which position of the element regarding to window should trigger the animation
    });
  });
  return (
    // <Heading id="aboutme" maxW="1348px" h="400px" bg="red">AboutMe Page</Heading>
    <Box maxW="1348px" className={styles.aboutContainer} marginTop="0px"

    >
      <Heading
        id="aboutme"
        fontSize={{ base: "100px", sm: "160px", md: "230px" }}
        color={useColorModeValue("gray.300", "gray.600")}
        className={styles.aboutHeading}
        fontFamily="'Playfair Display', serif"
        mb={{ base: "-20px", sm: "-40px", md: "-120px" }}
      // mt={{ base: "10px", sm: "30px", md: "50px" }}
      // bg="blue.100"
      >
        About
      </Heading>

      <SimpleGrid
        // bg="red.300"
        spacing="0px"
        maxW="1248px"
        columns={{ sm: 1, md: 2 }}
      >
        <Box
          data-aos="fade"
          data-aos-easing="ease-in-out"
          bg="blue. 300"
          height="auto"
          className={styles.aboutLeft}
          mb="50px"
        >
          <Image
            width="624px"
            src="https://natecoit.com/wp-content/uploads/2019/06/gif-4mb.gif"
          />
        </Box>
        <Box
          className={styles.aboutRight}
          height="auto"
          mt="-50px"
        // bg="yellow.30  0"
        >
          <Text as="p" data-aos="slide-up" data-aos-easing="ease-in-out">
            Since I was a kid I was a little good at drawing. Because of my drawing hobby. I decided to pursue a B.E. in Mechanical Engineering.
          </Text>
          <Text as="p" data-aos="slide-up" data-aos-easing="ease-in-out">
            However, a few years in, I realized that no matter the machine, it can be only automated by code. That is how I developed an interest in coding.
          </Text>
          <Text as="p" data-aos="slide-up" data-aos-easing="ease-in-out">
            I want to understand programming in depth and problem-solving skills. So I decide to move my career to the IT world and joined Masai School.
          </Text>
          <Text as="p" data-aos="slide-up" data-aos-easing="ease-in-out">
            At Masai, I learn Web Development and Data Structure, Algorithms (DSA) from the very basics. Learn Frontend and Backend Technology.
          </Text>
        </Box>
      </SimpleGrid>
    </Box>
  );
}
